import React, { useRef, useEffect, useState } from "react";
import {
  Modal,
  Box,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalOverlay,
  ModalContent,
  useDisclosure,
} from "@chakra-ui/react";
const ModalFormPreview = ({ children, shouldOpen, handlePreviewModeClose }) => {
  const [showModal, setShowModal] = useState(shouldOpen);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const initialRef = useRef();
  const finalRef = useRef();

  useEffect(() => {
    if (showModal) {
      onOpen();
    }
  }, [showModal]);
  return (
    <>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        size="lg"
        onClose={(e) => handlePreviewModeClose(onClose)}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize="18px">Form Preview</ModalHeader>
          <ModalCloseButton />
          <ModalBody mb="2rem">{children}</ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalFormPreview;
